import { BaseProvider } from '@!/providers'
import { useAppSettings } from '@!/Hooks/useAppSettings'
import { Login } from '../containers/Login'

export default function LoginApp(props) {
  const jotaiStore = useAppSettings({
    isSaveLastUrl: false,
    csrfToken: props.csrf_token,
    csrfParams: props.csrf_params,
  })

  return (
    <BaseProvider jotaiStore={jotaiStore}>
      <Login />
    </BaseProvider>
  )
}
